<!--

企业实体管理界面

-->
<template>
  <div>
    <el-card
      style="height: 680px"
    >
      <enterprise-detail  ref="enterpriseDetail"/>
    </el-card>
  </div>
</template>

<script>
import { listMyEnterprises ,enterpriseDetail} from '@/api/enterprise.js'
import EnterpriseDetail from './Detail.vue'
import EnterpriseAdd from './Add.vue'

export default {
  name: 'Enterprise',
  components: { EnterpriseDetail, EnterpriseAdd },
  data() {
    return {
      baseMap: undefined,
      /**
       * 活动标签页的name，缺省显示“新增”标签页
       */
      activeTab: 'enterprise',
      /**
       * 企业列表
       */
      enterprises: [],
    }
  },
  watch:{
    activeTab(val) {
      console.log("enterprise",val)
      if(val=='newone'){
        this.$refs['enterprise-newone'].clean()

      }else{
        if(!this.$refs[`enterprise-${val}`]){
          return
        }
        this.$refs[`enterprise-${val}`][0].enterpriseDetailGet()
      }

    }
  },
  computed: {
    userId() {
      return this.$store.getters.userId
    },
    currentEnterprise() {
      return this.$store.getters.currentEnterprise
    },
  },
  mounted() {
    // this.enterPriseData()
  },
  methods: {
    enterPriseData() {
      // TODO 此处应该取当前用户personId
      listMyEnterprises(this.userId).then((resp) => {
        const enterprises = resp.data
        this.enterprises = enterprises

        if (enterprises && enterprises.length > 0)
          this.activeTab = enterprises[0].id.toString()

      })
    },
    enterPriseDetailGet() {
      enterpriseDetail(this.currentEnterprise.id).then()
    },
    added(data) {
      this.enterPriseData()
      console.log('公司列表',this.enterprises)
    },
    tabLeave(activeName, oldActiveName) {
      const oldTab = this.$refs[`enterprise-${oldActiveName}`]
      if (!oldTab || !oldTab.leave) return
      if (oldTab.length) {
        // tab是数组，有长度，则表示是已有实体的tab（v-for产生的）
        return oldTab[0].leave()
      } else {
        // tab是对象，没有长度，则表示是新增的tab
        return oldTab.leave()
      }
    },
    rest() {
      this.$refs[`enterprise-${this.activeTab}`][0].enterpriseDetailGet()
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/meta/enterprise/Index.vue